import { render, staticRenderFns } from "./ConfigBase.vue?vue&type=template&id=18fe45f3&"
import script from "./ConfigBase.vue?vue&type=script&lang=js&"
export * from "./ConfigBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports